var React = require('react');
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
var Router = require('react-router-dom');
var {NavLink} = Router;

var SidemenuItem = createClass({
  displayName: 'SidemenuItem',

  propTypes: {
    linkTo: PropTypes.string,
    icon: PropTypes.string,
    label: PropTypes.string.isRequired
  },

  render() {
    return (
      <NavLink
        to={this.props.linkTo}
        className='vf-nav-sidemenu-item padding-horizontal-2x flex flex-stretch'
        activeClassName='active'>

        <i className={'vf-icon icon-' + this.props.icon} ></i>
        <div className='vf-nav-sidemenu-item-label flex-1'>
          {this.props.label}
        </div>

      </NavLink>
    );
  }
});

module.exports = SidemenuItem;
